import React from "react";
import { Dropdown } from "antd";
import { ChevronDown } from "lucide-react";

const PILL_CLASSNAME =
  "bg-gradient-to-r from-orange-500 to-amber-400 text-white text-[11px] md:text-xs font-semibold px-3 md:px-4 py-2 rounded-full shadow-md border border-orange-200/40 whitespace-nowrap z-[9999]";

// Renders the "PIU Playbook / Election Mode Playbook / SIR Report" navbar
// control: nothing if the client has none of them, a single pill button if
// there's exactly one, or a dropdown listing all of them if there's more
// than one — so the navbar never wastes space on buttons the client can't use.
const ReportsMenu = ({ items, className = PILL_CLASSNAME }) => {
  const available = (items || []).filter(Boolean);

  if (available.length === 0) return null;

  if (available.length === 1) {
    const only = available[0];
    return (
      <button type="button" onClick={only.onClick} className={className}>
        {only.label}
      </button>
    );
  }

  const menu = {
    items: available.map((item) => ({ key: item.key, label: item.label, onClick: item.onClick })),
  };

  return (
    <Dropdown
      menu={menu}
      trigger={["click"]}
      placement="bottomRight"
      getPopupContainer={() => document.body}
      overlayStyle={{ zIndex: 10001 }}
    >
      <button type="button" className={`${className} flex items-center gap-1`}>
        Reports
        <ChevronDown size={12} />
      </button>
    </Dropdown>
  );
};

export default ReportsMenu;
